import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_PARAMETERS = "getPaginatedParameters";
export const ALL_PARAMETERS = "getAllParameters";
export const CREATE_PARAMETER_FORM = "createParameterForm";
export const DELETE_PARAMETER = "deleteParameter";
export const GET_PARAMETER_DATA = "getParameterData";
export const CREATE_PARAMETER = "createParameter";
export const UPDATE_PARAMETER = "updateParameter";


// mutation types

export const SET_PAGINATED_PARAMETERS = "setPaginatedParameters";
export const SET_ALL_PARAMETERS = "setAllParameters";
export const SET_PARAMETER_DATA = "setParameterData";
export const SET_PARAMETER_META = "setParameterMeta";
export const SET_PARAMETER_ERROR = "setParameterError";
export const SET_PARAMETER_LOADING = "setParameterLoading";
export const CLEAR_PARAMETER_ERROR = "clearParameterError";
export const SET_IS_DISABLED_PARAMETER = "setIsDisabledParameter";


const state = {
    parameters: [],
    paginatedParameters: [],
    parameter_data: {},
    meta_parameter : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllParameters(state) {
        return state.paginatedParameters;
    },

    allParameters(state) {
        return state.parameters;
    },

    getParameterData(state) {
        return state.parameter_data;
    },

    meta_parameter(state) {
        return state.meta_parameter;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_PARAMETERS](context, payload) {
        context.commit(SET_IS_DISABLED_PARAMETER, false);
        context.commit(SET_PARAMETER_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/parameters?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_PARAMETER_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_PARAMETERS, data);
                context.commit(SET_PARAMETER_META, data);
                context.commit(SET_PARAMETER_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_PARAMETER_LOADING, false);
            context.commit(SET_PARAMETER_ERROR, response.errors);
        });
        ;
        
    },

    [ALL_PARAMETERS]() {
        return new Promise(resolve => {
            ApiService.get('/parametersAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_PARAMETER_FORM](context) {
        context.commit(SET_PARAMETER_LOADING, false);
        context.commit(SET_PARAMETER_ERROR, false);
        context.commit(SET_IS_DISABLED_PARAMETER, false);
    },

    [GET_PARAMETER_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_PARAMETER, true);
        context.commit(SET_PARAMETER_LOADING, true);
        context.commit(CLEAR_PARAMETER_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/parameter/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_PARAMETER_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_PARAMETER_DATA, response.data);
                    context.commit(SET_PARAMETER_LOADING, false);
                    context.commit(SET_IS_DISABLED_PARAMETER, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_PARAMETER_LOADING, false);
                context.commit(SET_PARAMETER_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_PARAMETER, true);
            });
        });
    },

    [CREATE_PARAMETER](context, payload) {
        context.commit(SET_PARAMETER_LOADING, false);
        context.commit(SET_IS_DISABLED_PARAMETER, true);
        context.commit(CLEAR_PARAMETER_ERROR);
        return ApiService.post("/parameter/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_PARAMETER_ERROR);
            }
            else{
                context.commit(SET_PARAMETER_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Parametre başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_PARAMETER_ERROR);
                context.commit(SET_IS_DISABLED_PARAMETER, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_PARAMETER_LOADING, false);
            context.commit(SET_PARAMETER_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PARAMETER, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_PARAMETER](context, payload) {
        context.commit(SET_PARAMETER_LOADING, true);
        context.commit(SET_IS_DISABLED_PARAMETER, true);
        context.commit(CLEAR_PARAMETER_ERROR);
        
        return ApiService.put(`/parameter/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_PARAMETER_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı parametre başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_PARAMETER, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_PARAMETER_LOADING, false);
            context.commit(SET_PARAMETER_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_PARAMETER, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_PARAMETER](context, payload) {
        context.commit(SET_PARAMETER_LOADING, true);
        context.commit(CLEAR_PARAMETER_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/parameter/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_PARAMETER_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else {
                
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı parametre başarıyla silinmiştir."
                );
                
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_PARAMETER_ERROR, error);
            AlertService.makeToast(
                "warning",
                "Hata!",
                error
            );
        });
        
    },

    
    
};

const mutations = {

    [SET_PAGINATED_PARAMETERS](state, paginatedParameters) {
        state.paginatedParameters = paginatedParameters.data;
    },

    [SET_ALL_PARAMETERS](state, parameters) {
        state.parameters = parameters;
    },

    [SET_PARAMETER_DATA](state, parameters_data) {
        state.parameters_data = parameters_data;
        state.errors = [];
    },

    [SET_PARAMETER_META](state, meta_parameter) {
        state.meta_parameter = meta_parameter;
    },

    [SET_PARAMETER_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_PARAMETER_ERROR](state) {
        state.errors = [];
    },
    
    [SET_PARAMETER_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_PARAMETER](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
